export const page = {
  hero: {
    title: {
      pt1: 'A',
      pt2: 'premium website',
      pt3: 'tailored for your restaurant'
    },
    description: 'Bistroo\'s website page-builder offers the tools to create a fully branded, high-converting landing page that enhances your customers ordering experience from start to finish.',
    button: 'Create website'
  },
  paragraphs: {
    paragraph_1: {
      title: 'Easy to build, effortless to maintain',
      text: 'The website is generated based on your store\'s information and easily customisable to perfectly fit your restaurant\'s style and branding.',
      cta: 'Explore the Bistroo packages'
    },
    paragraph_2: {
      title: 'Updated automatically',
      text: 'Any changes made in the Bistroo Manager are instantly reflected on your website, eliminating the need to update information manually on multiple editors or locations.',
      cta: ''
    },
    paragraph_3: {
      title: 'Serve a superior customer experience',
      text: 'From the first click to the final checkout, your customers enjoy a seamless and well-designed ordering journey that delivers excellence at every step - boosting their experience and your restaurant’s reputation in the process.',
      cta: 'Explore the Bistroo packages'
    },
    paragraph_4: {
      title: 'Optimised for online use and e-commerce',
      text: 'Our landing pages are designed and built for search engine optimisation and advertising effectiveness. Reach to the top of organic search result in your region or boost your website with cost-efficient advertising.',
      cta: ''
    }
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Put your best sellers in the spotlight.',
        text: 'Your menu changes and top-selling items are seamlessly connected to your website - no extra work needed.',
        button: '',
        img_alt: ''
      },
      card_2: {
        title: 'Integrations.',
        text: 'Connect your preferred reservations tooling to your landing page.',
        button: '',
        img_alt: ''
      },
      card_3: {
        title: 'Share and present key information.',
        text: 'Clearly communicate key information through your website, by changing the settings in the Manager app.',
        button: '',
        img_alt: ''
      },
      card_4: {
        title: 'Contact forms.',
        text: 'Allow for requests through integrated contact forms',
        button: '',
        img_alt: ''
      },
      card_5: {
        title: 'Optimised for all channels.',
        text: 'All websites are optimised for Google Search, but also for viewing on all types of devices.',
        button: '',
        img_alt: ''
      }
    }
  },
  testimonial: {
    text: '"Bistroo saves us a lot of time every day and significantly improves customer experience while reducing customer friction."',
    cta: 'Read Mondie\'s story',
    name: 'Two-B by Mondie',
    job_title: 'Lunchroom'
  }
}